var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHygeianLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 427.1 489.52",
    style: {
      enableBackground: "new 0 0 427.1 489.52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3E4548;}\r\n\t.st1{fill:#93B617;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33.39,
    y: 11.29,
    className: "st0",
    width: 97.29,
    height: 455.57
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.2,
    y: 11.29,
    className: "st0",
    width: 97.29,
    height: 455.57
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.99,489.18C197.16,357.22,127.14,250.94,1.85,173.29l3.03-6.27c87.89,31.81,156.17,71.71,208.61,121.93 c51.92-49.01,120.17-88.91,208.54-121.91l3.15,6.2c-125.91,83.15-195.97,189.45-208.22,315.95L209.99,489.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M423.25,170.32c-125.72,83.02-197.18,188.56-209.78,318.53c-12.94-133.1-82.32-239.53-209.78-318.53 c82.28,29.78,154.04,69.25,209.78,123.48C268.23,241.28,339.92,201.44,423.25,170.32 M6.07,163.73L0,176.26 C124.31,253.3,193.78,358.7,206.5,489.52h13.93c12.15-125.4,81.69-230.83,206.67-313.36l-6.31-12.4 c-43.25,16.15-82.5,34.4-116.66,54.22c-34.31,19.91-64.76,42.14-90.63,66.16C161.04,234.65,93.1,195.23,6.07,163.73L6.07,163.73z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 216.28,
    cy: 201.89,
    r: 45.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHygeianLogoSmall);
export default __webpack_public_path__ + "static/media/HygeianLogoSmall.5c6c55f0af8fd38ff515a935112fe52a.svg";
export { ForwardRef as ReactComponent };